module.exports = __webpack_public_path__ + "img/split.361671fa.svg";